<!-- src/views/pages/finance-accounts/sales/provident-table.vue -->
<script setup>
import { computed } from "vue";
import { useProvidentStore } from "@/stores/providentStore";

const emit = defineEmits(["edit", "delete"]);
const store = useProvidentStore();

const columns = [
  { title: "Employee Name", key: "employee" },
  { title: "Fund Type", key: "fund_type" },
  { title: "Employee Share (%)", key: "esp" },
  { title: "Org Share (%)", key: "osp" },
  { title: "Employee Amount", key: "esa" },
  { title: "Organization Amount", key: "osa" },
  { title: "Status", key: "status" },
  { title: "", key: "action" },
];

const tableData = computed(() =>
  store.items.map((r) => ({
    key: r.id,
    id: r.id,
    employee: `${r.employee?.first_name} ${r.employee?.last_name}`,
    img: r.employee?.avatar_url,
    fund_type: r.fund_type === "Employee" ? "Employee Provident Fund" : "Voluntary Provident Fund",
    esp: `${r.employee_share_percent ?? 0}%`,
    osp: `${r.organization_share_percent ?? 0}%`,
    esa: r.employee_share_amount,
    osa: r.organization_share_amount,
    status: r.status,
    raw: r,
  }))
);
</script>

<template>
  <a-table class="table datatable thead-light" :columns="columns" :data-source="tableData" :pagination="false" row-key="key">
    <template #bodyCell="{ column, record }">

      <!-- Employee -->
      <template v-if="column.key === 'employee'">
        <div class="d-flex align-items-center">
          <span class="avatar avatar-md avatar-rounded me-2">
            <img :src="record.img || require('@/assets/img/users/user-01.jpg')" class="img-fluid" />
          </span>
          <div>
            <h6 class="fw-medium">{{ record.employee }}</h6>
          </div>
        </div>
      </template>

      <!-- Status -->
      <template v-else-if="column.key === 'status'">
        <span :class="['badge', record.status === 'Approved' ? 'badge-success' : 'badge-info']">
          <i class="ti ti-point-filled me-1"></i>{{ record.status }}
        </span>
      </template>

      <!-- Actions -->
      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a href="javascript:void(0);" class="me-2" @click="emit('edit', record.raw)" v-can="'ProvidentFund.Edit'">
            <i class="ti ti-edit"></i>
          </a>
          <a href="javascript:void(0);" @click="emit('delete', record.raw)" v-can="'ProvidentFund.Delete'">
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>

      <!-- Fallback -->
      <template v-else>
        {{ record[column.key] }}
      </template>
    </template>
  </a-table>
</template>
